/* ARCHIVES MODAL (2026-10-07) — le lien "Archives" du menu (voir snippets/main-nav-links.liquid,
   attribut data-archives-open) ouvre ce modal au lieu d'un sous-menu. Choix : saison (Hiver/Ete),
   genre (Fille/Garcon), pointure (facultative, uniquement celles EN STOCK pour la saison+genre
   choisis) -> navigue vers la collection Outlet de la saison, deja filtree :
   ?filter.p.m.catalogue.cibles=FILLE[&filter.v.option.pointure=NN]. Le filtre de pointure est ensuite
   re-verifie cote client par assets/pointure-swatch-fix.js (stock reel).
   Les donnees (produits/pointures en stock) viennent de sections/archives-data.liquid, chargees a
   la 1re ouverture seulement. Le DOM du modal est construit ici (aucune modification de layout).

   2026-10-08 — MESURE (demande utilisateur : "vraie strate d'analyse" de l'Outlet). Trois sources
   independantes, memes principes que le guide du chaussant (assets/guide-du-chaussant.js) :
   1. EVENEMENTS GA4 (gtag, soumis au consentement) :
        archives_open    {device}
        archives_choice  {step: season|genre|size, value, season, genre, size, results}
        archives_apply   {season, genre, size, results, seconds_to_apply, device}
        archives_close   {steps_done, season, genre, size, seconds_open}   (abandon du modal, sans validation)
        archives_landing {season, genre, size, results_shown}   (page collection d'arrivee, apres filtre stock)
        archives_leave   {season, genre, size, seconds_on_page, product_viewed}   (quitte la collection)
        archives_product_view {season, genre, size, product}   (fiche produit vue dans la foulee)
        archives_add_to_cart / archives_remove_from_cart {product, variant, variant_price, season, genre, size}
        archives_cart_view {season, genre, size}   (page panier ouverte apres un passage Archives)
      `results` = nb de modeles EN STOCK pour le choix courant (0 = demande sans offre). Les memes
      evenements sont publies via Shopify.analytics.publish (pixel personnalise optionnel).
      gtag peut etre defini apres ce script (defer) : track() re-essaie jusqu'a 6 s avant d'abandonner.
   2. ATTRIBUT DE PANIER "Archives" ("Hiver · Fille · 22" ou "... · toutes pointures") via /cart/update.js
      juste avant la navigation : suit le panier jusqu'a la commande Shopify (customAttributes) ET
      jusqu'au checkout abandonne = mesure de transformation ET d'abandon panier/checkout INDEPENDANTE
      de GA4 (GA4 ne voit qu'une partie des commandes, voir memoire pomdapi_ga4_reporting). Les produits
      Outlet portent la promotion Discount Ninja OUTLET : la remise se lit sur les lignes de commande.
   3. PARAMETRES D'URL sur la collection d'arrivee : archives=menu&arch_s=hiver&arch_g=FILLE&arch_p=22
      + contexte en sessionStorage (24 h) pour rattacher fiche produit / panier au passage Archives. */
(function () {
  "use strict";

  var SEASONS = [
    { key: "hiver", label: "Hiver", sub: "Automne · Hiver", handle: "outlet-hiver" },
    { key: "ete", label: "Été", sub: "Printemps · Été", handle: "outlet-ete-1" }
  ];
  var GENRES = [
    { key: "FILLE", label: "Fille" },
    { key: "GARCON", label: "Garçon" }
  ];
  var CART_ATTRIBUTE = "Archives";
  var CTX_KEY = "archivesCtx";
  var state = { season: null, genre: null, size: null };
  var data = null; // { hiver: [{g:[...], s:[...]}], ete: [...] }
  var root = null;
  var lastFocus = null;
  var openedAt = 0;
  var applied = false;

  /* ---------- mesure ---------- */
  function device() {
    return window.innerWidth <= 767 ? "mobile" : "desktop";
  }

  function track(name, params, attempt) {
    params = params || {};
    attempt = attempt || 0;
    if (typeof window.gtag !== "function" && attempt < 6) {
      setTimeout(function () { track(name, params, attempt + 1); }, 1000);
      return;
    }
    try {
      if (typeof window.gtag === "function") window.gtag("event", name, params);
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
        window.Shopify.analytics.publish(name, params);
      }
    } catch (e) {}
  }

  function seasonLabel(key) {
    for (var i = 0; i < SEASONS.length; i++) if (SEASONS[i].key === key) return SEASONS[i].label;
    return key || "";
  }
  function genreLabel(key) {
    for (var i = 0; i < GENRES.length; i++) if (GENRES[i].key === key) return GENRES[i].label;
    return key || "";
  }

  function currentParams(extra) {
    var p = { season: state.season || "(non choisi)", genre: state.genre || "(non choisi)", size: state.size || "toutes" };
    if (extra) for (var k in extra) p[k] = extra[k];
    return p;
  }

  // Enregistre l'attribut de panier puis appelle done(), au plus tard apres 1,2 s.
  function saveCartAttribute(value, done) {
    var finished = false;
    function go() {
      if (finished) return;
      finished = true;
      done();
    }
    setTimeout(go, 1200);
    try {
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      var attributes = {};
      attributes[CART_ATTRIBUTE] = value;
      fetch(rootUrl + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ attributes: attributes }),
        keepalive: true
      }).then(go, go);
    } catch (e) {
      go();
    }
  }

  function readCtx() {
    try {
      return JSON.parse(sessionStorage.getItem(CTX_KEY) || "null");
    } catch (e) {
      return null;
    }
  }
  function writeCtx(ctx) {
    try {
      sessionStorage.setItem(CTX_KEY, JSON.stringify(ctx));
    } catch (e) {}
  }
  // Contexte Archives encore valable (24 h) ou null.
  function ctxActive() {
    var c = readCtx();
    return c && Date.now() - (c.t || 0) < 86400000 ? c : null;
  }

  /* ---------- donnees ---------- */
  function parseRows(str) {
    return (str || "").split("~").filter(Boolean).map(function (row) {
      var parts = row.split(";");
      return {
        g: (parts[0] || "").split(",").filter(Boolean),
        s: (parts[1] || "").split("|").filter(Boolean)
      };
    });
  }

  function loadData(cb) {
    if (data) return cb();
    fetch("/?section_id=archives-data", { credentials: "same-origin" })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var el = doc.getElementById("archives-data");
        data = {
          hiver: parseRows(el && el.getAttribute("data-hiver")),
          ete: parseRows(el && el.getAttribute("data-ete"))
        };
        cb();
      })
      .catch(function () {
        data = { hiver: [], ete: [] };
        cb();
      });
  }

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function seasonDef(key) {
    for (var i = 0; i < SEASONS.length; i++) if (SEASONS[i].key === key) return SEASONS[i];
    return null;
  }

  // Produits en stock pour la saison + genre (+ pointure) choisis.
  function matching(season, genre, size) {
    return ((data && data[season]) || []).filter(function (p) {
      return p.g.indexOf(genre) !== -1 && (!size || p.s.indexOf(size) !== -1);
    });
  }

  function sizeList(season, genre) {
    var seen = {};
    matching(season, genre).forEach(function (p) { p.s.forEach(function (s) { seen[s] = true; }); });
    return Object.keys(seen).sort(function (a, b) {
      return (parseFloat(a) - parseFloat(b)) || (a < b ? -1 : 1);
    });
  }

  function resultsNow() {
    if (!(state.season && state.genre)) return null;
    return matching(state.season, state.genre, state.size).length;
  }

  /* ---------- modal ---------- */
  function build() {
    var wrap = document.createElement("div");
    wrap.className = "arch";
    wrap.hidden = true;
    wrap.setAttribute("role", "dialog");
    wrap.setAttribute("aria-modal", "true");
    wrap.setAttribute("aria-labelledby", "ArchTitle");
    wrap.innerHTML =
      '<div class="arch__backdrop" data-arch-close></div>' +
      '<div class="arch__panel">' +
      '<button type="button" class="arch__close" data-arch-close aria-label="Fermer">×</button>' +
      '<p class="arch__eyebrow">Pom d\'Api · Archives</p>' +
      '<h2 class="arch__title" id="ArchTitle">Les collections passées</h2>' +
      '<p class="arch__lead">Des modèles des saisons précédentes, toujours disponibles à prix réduits, dans la limite des stocks.</p>' +
      '<div class="arch__step"><p class="arch__label"><span>01</span>Saison</p><div class="arch__tiles" data-arch-seasons></div></div>' +
      '<div class="arch__step"><p class="arch__label"><span>02</span>Pour qui ?</p><div class="arch__tiles" data-arch-genres></div></div>' +
      '<div class="arch__step"><p class="arch__label"><span>03</span>Pointure</p><p class="arch__hint" data-arch-hint></p><div class="arch__sizes" data-arch-sizes></div></div>' +
      '<a class="arch__cta" data-arch-cta href="/collections/outlet-1" aria-disabled="true">Voir la sélection</a>' +
      '<p class="arch__note">Seules les pointures réellement en stock sont proposées.</p>' +
      '</div>';
    document.body.appendChild(wrap);
    root = wrap;

    wrap.addEventListener("click", function (e) {
      if (e.target.closest("[data-arch-close]")) return close();
      var s = e.target.closest("[data-arch-season]");
      if (s) {
        state.season = state.season === s.dataset.archSeason ? null : s.dataset.archSeason;
        state.size = null;
        render();
        if (state.season) track("archives_choice", currentParams({ step: "season", value: state.season, results: resultsNow() === null ? -1 : resultsNow() }));
        return;
      }
      var g = e.target.closest("[data-arch-genre]");
      if (g) {
        state.genre = state.genre === g.dataset.archGenre ? null : g.dataset.archGenre;
        state.size = null;
        render();
        if (state.genre) track("archives_choice", currentParams({ step: "genre", value: state.genre, results: resultsNow() === null ? -1 : resultsNow() }));
        return;
      }
      var z = e.target.closest("[data-arch-size]");
      if (z) {
        state.size = state.size === z.dataset.archSize ? null : z.dataset.archSize;
        render();
        if (state.size) track("archives_choice", currentParams({ step: "size", value: state.size, results: resultsNow() }));
        return;
      }
      var cta = e.target.closest("[data-arch-cta]");
      if (cta && cta.getAttribute("aria-disabled") !== "true") {
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
        e.preventDefault();
        apply(cta.getAttribute("href"));
      }
    });
  }

  function apply(url) {
    if (applied) return;
    applied = true;
    var results = resultsNow();
    var sizeTxt = state.size || "toutes pointures";
    track("archives_apply", currentParams({
      results: results,
      seconds_to_apply: Math.round((Date.now() - openedAt) / 1000),
      device: device()
    }));
    writeCtx({ season: state.season, genre: state.genre, size: state.size || "toutes", t: Date.now() });
    var sep = url.indexOf("?") === -1 ? "?" : "&";
    var dest = url + sep + "archives=menu&arch_s=" + encodeURIComponent(state.season) + "&arch_g=" + encodeURIComponent(state.genre) + "&arch_p=" + encodeURIComponent(state.size || "toutes");
    saveCartAttribute(seasonLabel(state.season) + " · " + genreLabel(state.genre) + " · " + sizeTxt, function () {
      window.location.href = dest;
    });
  }

  function render() {
    var seasons = root.querySelector("[data-arch-seasons]");
    seasons.innerHTML = SEASONS.map(function (s) {
      return '<button type="button" class="arch__tile" data-arch-season="' + s.key + '" aria-pressed="' + (state.season === s.key) + '">' + esc(s.label) + "<small>" + esc(s.sub) + "</small></button>";
    }).join("");
    root.querySelector("[data-arch-genres]").innerHTML = GENRES.map(function (g) {
      return '<button type="button" class="arch__tile" data-arch-genre="' + g.key + '" aria-pressed="' + (state.genre === g.key) + '">' + esc(g.label) + "</button>";
    }).join("");

    var sizesEl = root.querySelector("[data-arch-sizes]");
    var hint = root.querySelector("[data-arch-hint]");
    var cta = root.querySelector("[data-arch-cta]");
    var ready = state.season && state.genre;

    if (!ready) {
      sizesEl.innerHTML = "";
      hint.textContent = "Choisissez d'abord la saison et le genre.";
      cta.setAttribute("aria-disabled", "true");
      cta.textContent = "Voir la sélection";
      cta.setAttribute("href", "/collections/outlet-1");
      return;
    }

    var sizes = sizeList(state.season, state.genre);
    if (state.size && sizes.indexOf(state.size) === -1) state.size = null;
    hint.textContent = sizes.length ? "Facultatif — sans choix, toutes les pointures sont affichées." : "Aucun modèle en stock pour cette sélection pour le moment.";
    sizesEl.innerHTML = sizes.map(function (s) {
      return '<button type="button" class="arch__size" data-arch-size="' + esc(s) + '" aria-pressed="' + (state.size === s) + '">' + esc(s) + "</button>";
    }).join("");

    var n = matching(state.season, state.genre, state.size).length;
    var url = "/collections/" + seasonDef(state.season).handle + "?filter.p.m.catalogue.cibles=" + encodeURIComponent(state.genre);
    if (state.size) url += "&filter.v.option.pointure=" + encodeURIComponent(state.size);
    cta.setAttribute("href", url);
    cta.setAttribute("aria-disabled", n ? "false" : "true");
    cta.textContent = n ? "Voir " + n + " modèle" + (n > 1 ? "s" : "") : "Aucun modèle disponible";
  }

  function stepsDone() {
    return (state.season ? 1 : 0) + (state.genre ? 1 : 0) + (state.size ? 1 : 0);
  }

  function open() {
    lastFocus = document.activeElement;
    applied = false;
    loadData(function () {
      if (!root) build();
      render();
      root.hidden = false;
      openedAt = Date.now();
      document.body.classList.add("arch-lock");
      track("archives_open", { device: device() });
      var closeBtn = root.querySelector(".arch__close");
      if (closeBtn) closeBtn.focus();
    });
  }

  function close() {
    if (!root || root.hidden) return;
    root.hidden = true;
    document.body.classList.remove("arch-lock");
    if (!applied) {
      track("archives_close", currentParams({ steps_done: stepsDone(), seconds_open: Math.round((Date.now() - openedAt) / 1000), device: device() }));
    }
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener(
    "click",
    function (e) {
      var trigger = e.target.closest("[data-archives-open]");
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      open();
    },
    true
  );
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && root && !root.hidden) close();
  });

  /* ---------- panier : mise au panier / retrait (contexte Archives actif seulement) ---------- */
  if (typeof window.fetch === "function" && !window.__archivesFetchPatched) {
    window.__archivesFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var p = origFetch.apply(this, arguments);
      try {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        var c = ctxActive();
        var kind = /\/cart\/add(\.js)?(\?|$)/.test(url) ? "add" : /\/cart\/change(\.js)?(\?|$)/.test(url) ? "change" : "";
        if (c && kind) {
          var reqBody = init && typeof init.body === "string" ? init.body : "";
          p.then(function (res) {
            if (!res || !res.ok) return;
            res.clone().json().then(function (json) {
              var base = { season: c.season, genre: c.genre, size: c.size };
              if (kind === "add") {
                var item = (json && json.items && json.items[0]) || json || {};
                var price = typeof item.price === "number" ? item.price / 100 : undefined;
                track("archives_add_to_cart", Object.assign({
                  product: item.handle || (item.url || "").split("/")[2] || item.product_title || "",
                  variant: item.variant_title || "",
                  variant_price: price
                }, base));
              } else if (/"quantity"\s*:\s*0|quantity=0/.test(reqBody)) {
                track("archives_remove_from_cart", base);
              }
            }).catch(function () {});
          }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }

  /* ---------- pages d'arrivee / suite du parcours ---------- */
  document.addEventListener("DOMContentLoaded", function () {
    var qs = new URLSearchParams(window.location.search);

    if (qs.get("archives") === "menu") {
      var ctx = { season: qs.get("arch_s") || "", genre: qs.get("arch_g") || "", size: qs.get("arch_p") || "toutes", t: Date.now() };
      writeCtx(ctx);
      var landedAt = Date.now();
      var leaveSent = false;
      // Laisse pointure-swatch-fix.js appliquer le filtre de stock avant de compter les cartes visibles.
      setTimeout(function () {
        var cards = document.querySelectorAll(".product-grid__size-wrap");
        var shown = 0;
        cards.forEach(function (c) { if (c.style.display !== "none") shown++; });
        track("archives_landing", { season: ctx.season, genre: ctx.genre, size: ctx.size, results_shown: shown });
      }, 2500);
      // Sortie de la collection : abandon (aucune fiche ouverte) ou passage vers une fiche produit.
      var leave = function () {
        if (leaveSent) return;
        leaveSent = true;
        if (typeof window.gtag === "function") {
          window.gtag("event", "archives_leave", {
            season: ctx.season, genre: ctx.genre, size: ctx.size,
            seconds_on_page: Math.round((Date.now() - landedAt) / 1000),
            product_viewed: window.__archivesGoingToProduct ? "oui" : "non",
            transport_type: "beacon"
          });
        }
      };
      document.addEventListener("click", function (e) {
        var a = e.target.closest && e.target.closest("a[href*='/products/']");
        if (a) window.__archivesGoingToProduct = true;
      }, true);
      window.addEventListener("pagehide", leave);
      return;
    }

    var saved = ctxActive();
    if (!saved) return;

    if (/^\/cart/.test(window.location.pathname)) {
      track("archives_cart_view", { season: saved.season, genre: saved.genre, size: saved.size });
      return;
    }

    if (/^\/products\//.test(window.location.pathname)) {
      var handle = window.location.pathname.split("/")[2] || "";
      var seenKey = "archivesSeen:" + handle;
      try {
        if (sessionStorage.getItem(seenKey)) return;
        sessionStorage.setItem(seenKey, "1");
      } catch (e) {}
      track("archives_product_view", { season: saved.season, genre: saved.genre, size: saved.size, product: handle });
    }
  });
})();
